import React from "react";
import anoViannosBackground from "../assets/ano-viannos-background.jpg";
import localAreaMap from "../assets/local area static map.jpeg";
import UsefulInformation from "../components/UsefulInformation";
import { useLanguage } from "../contexts/LanguageProvider";
import { ACCESSIBILITY_OVERLAYS_ENABLED } from "../config/constants";
import { Card, CardContent } from "../components/ui/card";
import { Clock, MapPin } from "lucide-react";

export default function UsefulInformationPage() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center">
        <div className="absolute inset-0 z-0">
          <img
            src={anoViannosBackground}
            alt="Ano Viannos village"
            className="w-full h-full object-cover"
          />
          <div className={`absolute inset-0 ${ACCESSIBILITY_OVERLAYS_ENABLED ? 'bg-gradient-to-r from-gray-900/70 to-gray-800/50' : 'bg-gradient-to-r from-gray-900/35 to-gray-800/25'}`}></div>
        </div>
        
        <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight px-6 py-2 rounded-lg inline-block bg-black/60">
            {t('usefulInfoTitle')}
          </h1>
          <p className="text-xl md:text-2xl text-white max-w-2xl mx-auto leading-relaxed px-6 py-3 rounded-lg font-semibold bg-black/50">
            {t('usefulInfoSubtitle')}
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

        {/* Useful Information Component */}
        <section>
          <UsefulInformation />
        </section>

        {/* Map Section */}
        <section className="mt-16">
          <div className="text-center mb-8">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <MapPin className="inline-block w-10 h-10 mr-2 text-blue-600" />
              {t('contactMapTitle')}
            </h2>
            <p className="text-xl text-gray-600">
              {t('contactMapSubtitle')}
            </p>
          </div>
          
          <Card className="border-0 shadow-lg overflow-hidden">
            <CardContent className="p-0">
              <img
                src={localAreaMap}
                alt="Local area map showing Municipality of Viannos"
                className="w-full h-auto object-cover"
              />
            </CardContent>
          </Card>
        </section>

        {/* Amenities Section */}
        <section className="mt-16">
          <div className="text-center mb-8">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('localAmenities')}</h2>
            <p className="text-xl text-gray-600">
              {t('localAmenitiesSubtitle')}
            </p>
          </div>
          
          <Card className="border-0 shadow-lg">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-6 bg-blue-100 rounded-full flex items-center justify-center">
                <Clock className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">{t('contentComingSoon')}</h3>
              <p className="text-lg text-gray-600 mb-2">
                {t('gatheringInformation')}
              </p>
              <p className="text-gray-500">
                {t('pendingContent')}
              </p>
            </CardContent>
          </Card>
        </section>
      </div>
    </div>
  );
}
